var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',[_c('editor',{staticStyle:{"height":"70vh"},attrs:{"live":false},on:{"input":_vm.save},model:{value:(_vm.record.scratchpad),callback:function ($$v) {_vm.$set(_vm.record, "scratchpad", $$v)},expression:"record.scratchpad"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }